import { useTranslation } from 'react-i18next';
import { Text } from '@/components/ui/text';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { BaseModalProps } from '@/contexts/ModalContext';
import { DeleteConfirmationOptions } from '~/global/hooks/useDeleteConfirmation';

export interface DeleteConfirmationDialogProps extends BaseModalProps {
  onConfirm: () => void;
  options?: DeleteConfirmationOptions | null;
}

export const DeleteConfirmationDialog = ({
  onConfirm,
  onClose,
  options,
}: DeleteConfirmationDialogProps) => {
  const { t } = useTranslation('common');

  const title = options?.title || t('deleteConfirmation.title');
  const description =
    options?.description || t('deleteConfirmation.description');
  const confirmText = options?.confirmText || t('deleteConfirmation.confirm');
  const cancelText = options?.cancelText || t('deleteConfirmation.cancel');

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <AlertDialog open={true} onOpenChange={(open) => !open && handleCancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onPress={handleCancel}>
            <Text>{cancelText}</Text>
          </AlertDialogCancel>
          <AlertDialogAction onPress={handleConfirm} className="bg-destructive">
            <Text>{confirmText}</Text>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
